// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu[menuId=order-menu] {
  --background: #fff;
  --width: 78vw;
  --max-width: 300px;
}

.sm-toolbar {
  --background: #143D17;
  --border-width: 0;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --min-height: auto;
}

.sm-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: calc(env(safe-area-inset-top) + 12px) 16px 14px;
}

.sm-user-block {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.sm-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #2E7D32;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-transform: uppercase;
}

.sm-avatar-guest {
  background: rgba(255, 255, 255, 0.15);
}
.sm-avatar-guest svg {
  stroke: #fff;
}

.sm-user-info {
  min-width: 0;
}

.sm-hello {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 1px;
}

.sm-name {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sm-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.sm-content {
  --background: #f7f7f7;
}

.sm-list {
  padding: 10px 12px;
}

.sm-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 14px;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 6px;
  cursor: pointer;
}
.sm-item:active {
  opacity: 0.8;
}

.sm-item-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #E8F5E9;
  color: currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sm-item-label {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
}

.sm-item-arrow {
  font-size: 18px;
  color: #ccc;
  line-height: 1;
}

.sm-item-logout .sm-item-icon {
  background: #fef0f0;
  color: #e04040;
}
.sm-item-logout .sm-item-label {
  color: #e04040;
}

.sm-divider {
  height: 0.5px;
  background: #eee;
  margin: 6px 0 10px;
}

.sm-submenu {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 6px;
  overflow: hidden;
}

.sm-sub-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  font-size: 13px;
  color: var(--ion-color-green);
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  border-bottom: 0.5px solid #eee;
}
.sm-sub-item:last-child {
  border-bottom: none;
}
.sm-sub-item span {
  color: #1a1a1a;
}
.sm-sub-item:active {
  background: #E8F5E9;
}

.offline-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.offline-card {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  max-width: 320px;
  width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: fadeInUp 0.4s ease-out;
}

.icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 0, 22, 0.06); /* even softer red tint */
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.icon-circle svg {
  width: 42px;
  height: 42px;
  display: block;
}

.offline-card h2 {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

.offline-card p {
  margin: 0 0 24px;
  font-size: 15px;
  color: #666;
  line-height: 1.5;
}

.pulse-dot {
  width: 12px;
  height: 12px;
  background: #ff0016;
  border-radius: 50%;
  margin: 0 auto 12px;
  animation: pulse 1.5s infinite;
}

.reconnect-text {
  font-size: 14px;
  color: #888;
  margin: 0;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAUA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;AATF;;AAYA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,wDAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBA5Ce;EA6Cf,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;AATF;;AAYA;EACE,qCAAA;AATF;AAUE;EAAM,YAAA;AAPR;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAPF;AASE;EACE,YAAA;AAPJ;;AAWA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAtHe;EAuHf,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AARF;;AAWA;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,cA/He;AAuHjB;;AAWA;EACE,eAAA;EACA,WAAA;EACA,cAAA;AARF;;AAYE;EACE,mBAAA;EACA,cAAA;AATJ;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,aAAA;EACA,gBAlJe;EAmJf,kBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,+BAAA;AAVF;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,cAhLa;AAqKjB;AAcE;EACE,mBAvLa;AA2KjB;;AAgBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,kCAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,2CAAA;EACA,iCAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA,EAAA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AAbF;;AAgBA;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAbF;;AAgBA;EACE;IACE,UAAA;IACA,2BAAA;EAbF;EAeA;IACE,UAAA;IACA,wBAAA;EAbF;AACF;AAgBA;EACE;IACE,UAAA;IACA,mBAAA;EAdF;EAgBA;IACE,YAAA;IACA,qBAAA;EAdF;EAgBA;IACE,UAAA;IACA,mBAAA;EAdF;AACF","sourcesContent":["// ─── Design tokens (mirrored from page files) ────────────────\r\n$primary:        #2E7D32;\r\n$primary-light:  #E8F5E9;\r\n$primary-border: #A5D6A7;\r\n$hero-bg:        #143D17;\r\n$text-primary:   #1a1a1a;\r\n$text-muted:     #888;\r\n$border:         #eee;\r\n\r\n// ─── Right menu (user/account) ───────────────────────────────\r\nion-menu[menuId=\"order-menu\"] {\r\n  --background: #fff;\r\n  --width: 78vw;\r\n  --max-width: 300px;\r\n}\r\n\r\n.sm-toolbar {\r\n  --background: #{$hero-bg};\r\n  --border-width: 0;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n  --padding-top: 0;\r\n  --padding-bottom: 0;\r\n  --min-height: auto;\r\n}\r\n\r\n.sm-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: calc(env(safe-area-inset-top) + 12px) 16px 14px;\r\n}\r\n\r\n.sm-user-block {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.sm-avatar {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  background: $primary;\r\n  color: #fff;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.sm-avatar-guest {\r\n  background: rgba(255, 255, 255, 0.15);  // was $primary-light (green tint)\r\n  svg { stroke: #fff; }                   // was hardcoded #2E7D32\r\n}\r\n\r\n.sm-user-info {\r\n  min-width: 0;\r\n}\r\n\r\n.sm-hello {\r\n  font-size: 11px;\r\n  color: rgba(255, 255, 255, 0.45);\r\n  margin-bottom: 1px;\r\n}\r\n\r\n.sm-name {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.sm-close-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 8px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sm-content {\r\n  --background: #f7f7f7;\r\n}\r\n\r\n.sm-list {\r\n  padding: 10px 12px;\r\n}\r\n\r\n.sm-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 13px 14px;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  margin-bottom: 6px;\r\n  cursor: pointer;\r\n\r\n  &:active {\r\n    opacity: 0.8;\r\n  }\r\n}\r\n\r\n.sm-item-icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 8px;\r\n  background: $primary-light;  // keep as-is (light tint, fine for both)\r\n  color: currentColor;  // was $primary\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sm-item-label {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: $text-primary;\r\n}\r\n\r\n.sm-item-arrow {\r\n  font-size: 18px;\r\n  color: #ccc;\r\n  line-height: 1;\r\n}\r\n\r\n.sm-item-logout {\r\n  .sm-item-icon {\r\n    background: #fef0f0;\r\n    color: #e04040;\r\n  }\r\n  .sm-item-label {\r\n    color: #e04040;\r\n  }\r\n}\r\n\r\n.sm-divider {\r\n  height: 0.5px;\r\n  background: $border;\r\n  margin: 6px 0 10px;\r\n}\r\n\r\n.sm-submenu {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  margin-bottom: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.sm-sub-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 12px 16px;\r\n  font-size: 13px;\r\n  color: var(--ion-color-green); \r\n  font-weight: 500;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  border-bottom: 0.5px solid $border;\r\n\r\n  &:last-child {\r\n    border-bottom: none;\r\n  }\r\n\r\n  span {\r\n    color: $text-primary;\r\n  }\r\n\r\n  &:active {\r\n    background: $primary-light;\r\n  }\r\n}\r\n\r\n.offline-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 99999;\r\n  backdrop-filter: blur(4px);\r\n  -webkit-backdrop-filter: blur(4px);\r\n}\r\n\r\n.offline-card {\r\n  background: white;\r\n  border-radius: 20px;\r\n  padding: 40px 30px;\r\n  text-align: center;\r\n  max-width: 320px;\r\n  width: 90%;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\r\n  animation: fadeInUp 0.4s ease-out;\r\n}\r\n\r\n.icon-circle {\r\n  width: 80px;\r\n  height: 80px;\r\n  border-radius: 50%;\r\n  background: rgba(255, 0, 22, 0.06); /* even softer red tint */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 24px;\r\n}\r\n\r\n.icon-circle svg {\r\n  width: 42px;\r\n  height: 42px;\r\n  display: block;\r\n}\r\n\r\n.offline-card h2 {\r\n  margin: 0 0 12px;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #333;\r\n}\r\n\r\n.offline-card p {\r\n  margin: 0 0 24px;\r\n  font-size: 15px;\r\n  color: #666;\r\n  line-height: 1.5;\r\n}\r\n\r\n.pulse-dot {\r\n  width: 12px;\r\n  height: 12px;\r\n  background: #ff0016;\r\n  border-radius: 50%;\r\n  margin: 0 auto 12px;\r\n  animation: pulse 1.5s infinite;\r\n}\r\n\r\n.reconnect-text {\r\n  font-size: 14px;\r\n  color: #888;\r\n  margin: 0;\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.6;\r\n    transform: scale(1.2);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
